import React, { useEffect, useState } from 'react';
import { Col, Container, Form, FormGroup, Label, Row } from 'reactstrap';
import {
  CommonButton,
  ErrorBlock,
  SingleSlectSearch,
} from '../../../Components/CommonComponents';
import './index.css';
import ModalService from '../../../services/ModalService';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import { DashBoardTitle } from '../../../Components/Title';
import { assignTerritory, getTerritoryTM } from '../../../constants/apiCalls';
import { handleErrorMessage } from '../../../utils/utils';
import swal from 'sweetalert';
import { useNavigate } from 'react-router-dom';
import { Permissions } from '../../../constants/Permissions';
import { useSelector } from 'react-redux';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

const ChangeTerritoryManager = () => {

  const navigate = useNavigate();
  const { permissionArr } = useSelector(state => state.UserGetReducer)
  const localPermission = permissionArr;
  useEffect(() => {
    if (!localPermission.includes(Permissions.ADMIN_ASSIGN_TERRITORIES)) {
      navigate('/');
    }
  }, [...localPermission])

  const [isLoading, setIsloading] = useState(false);
  const [allData, setAllData] = useState([]);
  const [territoryArr, setTerritoryArr] = useState([]);
  const [territory, setTerritory] = useState('');
  const [territoryName, setTerritoryName] = useState('');
  const [currentTm, setCurrentTm] = useState([]);

  const [assignedTmArr, setAssignedTmArr] = useState([]);
  const [tm, setTm] = useState('');
  const [errorMsg, setErrorMsg] = useState({ tmError: '', assignTmErr: '' });


  useEffect(() => {
    setIsloading(true);
    getTerritoryTMList();
  }, [])

  const getTerritoryTMList = () => {
    getTerritoryTM((res) => {
      const { data, success, error } = res;
      if (success === true) {
        if (data && data.length > 0) {
          setAllData(data);
          if (data[0].territory && data[0].territory.length > 0) {
            let newTerritoryArr = data[0].territory.map(function (obj) {
              obj['label'] = obj['name']; // Assign new key new = old
              obj['value'] = obj['territory_id']; // Assign new key
              delete obj['name']; // Delete old key
              delete obj['territory_id'];
              return obj;
            });
            setTerritoryArr(newTerritoryArr);
          }
          if (data[0].territory_manager && data[0].territory_manager.length > 0) {
            let newTmArr = data[0].territory_manager.map(function (obj) {
              obj['label'] = obj['name']; // Assign new key new = old
              obj['value'] = obj['tm_id']; // Assign new key
              delete obj['name']; // Delete old key
              delete obj['tm_id'];
              return obj;
            });

            // tm_id key converterd to value
            let uniqueTmArr =
              newTmArr && newTmArr.length > 0
                ? [
                  ...new Map(
                    newTmArr.map((m) => [m.value, m])
                  ).values(),
                ]
                : [];
            setAssignedTmArr(uniqueTmArr);
          }
        }
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    });
  }

  const handleChangeTerritory = (e) => {
    let val = e && e.value ? e : null;
    setTerritory(val);
    setTm('');
    setErrorMsg({ ...errorMsg, tmError: '' });
    if (val && val.label && val.value) {

      // Show Territory Name
      setTerritoryName(val.label);

      // Filter current TM
      let filterCurrentTmArr = allData[0].territory_manager && allData[0].territory_manager.length > 0 ? allData[0].territory_manager.filter(e => e.territory_id === val.value) : [];
      setCurrentTm(filterCurrentTmArr);

    } else {
      setTerritoryName('');
      setCurrentTm([]);
    }
  };

  const handleAssignTM = (e) => {
    let val = e && e.value ? e : null;
    setErrorMsg({ ...errorMsg, assignTmErr: '' });
    setTm(val);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!territory) {
      setErrorMsg({ ...errorMsg, tmError: 'Please select Territory' });
    }
    if (!tm) {
      setErrorMsg({ ...errorMsg, assignTmErr: 'Please select Assigned TM' });
    }
    if (territory && tm) {
      setErrorMsg({});


      swal({
        title: 'Assign New TM',
        text: 'Are you sure want to update territory manager?',
        icon: 'warning',
        buttons: ['No', 'Yes'],
      }).then((isConfirm) => {
        if (isConfirm) {
          let payload = {
            territory_id: territory.value || '',
            new_tm_id: tm.value || '',
            old_tm_id: currentTm && currentTm.length > 0 ? currentTm[0].value : '',
          }
          setIsloading(true);
          assignTerritory((res) => {
            const { success, message, error } = res;
            if (success === true) {
              ModalService.openAlert('', message, 'success');
              setTerritory('');
              setTm('');
              setTerritoryName('');
              setCurrentTm([]);
              getTerritoryTMList();
              setIsloading(false);
            } else if (success === false || success === 'undefined') {
              ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
              setIsloading(false);
            }
            setIsloading(false);
          }, payload);
        } else {
          setIsloading(false)
        }
      });
    }
  };

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='changeTm'>
              {isLoading && <CustomSpinner />}
              <div className='pageWrapper'>
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className='pageheader'>
                        <DashBoardTitle dashBorardName='Change Territory Manager' className="lightTitle" />
                      </div>
                    </Col>
                  </Row>
                  <div className='mainArea'>
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Col xs={12}>
                          <div className='selectWrapper d-flex flex-wrap'>
                            <div className='selectBlock'>
                              <FormGroup>
                                <Label for='territory'>Territory <span className='required'>*</span></Label>
                                <SingleSlectSearch
                                  className='singleSelectOpt'
                                  classNamePrefix='select'
                                  name='territory'
                                  options={territoryArr}
                                  isSearchable={true}
                                  isClearable={true}
                                  // isDisabled={isDisabled}
                                  value={territory === null || territory === 'undefined' ? null : territory}
                                  onChange={(e) => handleChangeTerritory(e)}
                                // styles={customStyles}
                                />
                              </FormGroup>
                              {errorMsg.tmError ? (
                                <ErrorBlock title={errorMsg.tmError} />
                              ) : (
                                ''
                              )}
                            </div>
                            <div className='selectBlock'>
                              <FormGroup>
                                <Label for='assignedTm'>Assign New TM <span className='required'>*</span></Label>
                                <SingleSlectSearch
                                  className='singleSelectOpt'
                                  classNamePrefix='select'
                                  name='assignedTm'
                                  options={assignedTmArr}
                                  isSearchable={true}
                                  isClearable={true}
                                  // isDisabled={isDisabled}
                                  value={tm === null || tm === 'undefined' ? null : tm}
                                  onChange={(e) => handleAssignTM(e)}
                                // styles={customStyles}
                                />
                                {/* <SingleSelect
                          // required={true}
                          // disabled={editId}
                          name='assignedTm'
                          id='assignedTm'
                          // required
                          value={tm == null || tm == 'undefined' ? '' : tm}
                          onChange={(e) => handleAssignTM(e)}
                          options={assignedTmArr}
                          label={'label'}
                          selectedValueKey={'value'}
                        /> */}
                              </FormGroup>
                              {errorMsg.assignTmErr ? (
                                <ErrorBlock title={errorMsg.assignTmErr} />
                              ) : (
                                ''
                              )}
                            </div>
                          </div>
                        </Col>
                        {territoryName ? (
                          <Col xs={12}>
                            <p className='d-flex flex-wrap'>
                              <span className='mr-3'>
                                Territory:{' '}
                                <span className='blueText'>{territoryName}</span>
                              </span>
                              {currentTm && currentTm.length > 0 ? (
                                <span className='mr-3'>
                                  Current TM:{' '}
                                  {currentTm.map((e, index) => {
                                    return (
                                      <span className='blueText' key={index}>{(index ? ', ' : '') + e.label}</span>
                                    )
                                  })}
                                </span>
                              ) : ''}
                            </p>
                          </Col>
                        ) : (
                          ''
                        )}
                        <Col xs={12}>
                          <div className='text-center'>
                            <CommonButton
                              name={'Submit'}
                              btnClass={'btnPrimary'}
                              type='submit'
                              maxWidth='180px'
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangeTerritoryManager;
